import { render, staticRenderFns } from "./copy-link.vue?vue&type=template&id=24a5a1ac&"
import script from "./copy-link.vue?vue&type=script&lang=js&"
export * from "./copy-link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports